// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e67c4a5"};